import {_} from 'lodash';
import * as ko from "knockout";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {global} from "../../appContext";
import {ErrorTracker} from "../../error.tracker";
import {IType} from "./index";
import {ObjectTypeId, TEXT_WRAPPER_START} from "../../constants";
import {nsMessages} from "./fn";
import recipientsHtml from './recipients.html?raw';

export let template = recipientsHtml;

interface IParams {
    recipients: KnockoutObservable<string>
    validatorFn: (str: string) => boolean
    type: KnockoutObservable<IType>
}

interface IMutableRecipient {
    obs: KnockoutObservable<string>
}

export class viewModel {
    private ObjectTypeId = ObjectTypeId;
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly recipients: KnockoutObservableArray<IMutableRecipient> = ko.observableArray<IMutableRecipient>([]);
    private et: ErrorTracker = global.errorAreas.get("messages.mutable");
    private type: KnockoutObservable<IType>;

    constructor(private params: IParams) {
        this.type = params.type;
        if (params.recipients() !== '') {
            nsMessages
                .splitRecipients(params.recipients())
                .forEach((str: string) => {
                    this.createMutableRecipient(str);
                })
        }
        this.kosub.subscribe(this.recipients, () => {
            this.updateParamsRecipients();
        });
    }

    private createMutableRecipient(str: string = '') {
        const obj = {obs: ko.observable(str)};
        this.et.update(false, obj);
        this.kosub.subscribe(obj.obs, () => {
            this.validateRecipient(obj);
            this.updateParamsRecipients();
        });
        this.recipients.push(obj);
        this.validateRecipient(obj);
    }

    private validateRecipient(obj: IMutableRecipient) {
        const message = this.params.type().key == 'sms' ? '((invalid)) ((phone number|ac))' : 'invalid email';
        const a = this.params.validatorFn(obj.obs());
        this.et.update(!a, obj, message);
    }

    private updateParamsRecipients() {
        const str = _(this.recipients())
            .map((obj: IMutableRecipient) => {
                const val = obj.obs()
                return val.includes(TEXT_WRAPPER_START)
                    ? val
                    : val.replace(/ /g, '')
            })
            .uniq()
            .join(',');
        this.params.recipients(str);
    }

    private onAddClick() {
        this.createMutableRecipient();
    }

    private onDeleteClick(recipient: IMutableRecipient) {
        const index = this.recipients.indexOf(recipient);
        this.recipients.remove(recipient);
        global.snackbarData({
            message: `subject is removed|s:((recipient))`,
            undo: () => {
                this.recipients.splice(index, 0, recipient);
            },
        });
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
